import types from "../../types";
import Constants from "../../../services/constant";
import { showLoaderAction, hideLoaderAction } from "../loadAction";
import { api } from "../../../services/api";

export const getParentContactAction = () => async (dispatch) => {
  dispatch(showLoaderAction());

  const res = await api("get", Constants.END_POINT.PARENT_CONTACT_INFO);


  if (res.success) {
    dispatch({
      type: types.GET_PARENT_CONTACT,
      payload: res.data,
    });
  }

  dispatch(hideLoaderAction());
};